import 'twin.macro';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Snackbar, { SnackbarVariants } from '@/components/Snackbar';
import IntervieweeCardContainer from '@/containers/IntervieweeCardContainer';
import QuestionSnapshotContainer from '@/containers/QuestionSnapshotContainer';
import { useGetQuestionSnapshotBySessionIdQuery, useGetSessionQuery } from '@/domains/session';
import { IntervieweeInfoType, convertIntervieweeInfo } from '@/utils/convertIntervieweeInfo';

const Interviewee = () => {
  const params = useParams();
  const { t } = useTranslation();

  const sessionId = params.intervieweeId ?? '';

  const {
    data: sessionData,
    loading: sessionLoading,
    refetch: refetchSession,
  } = useGetSessionQuery({
    variables: { sessionId },
    fetchPolicy: 'network-only',
  });

  const {
    data: questionSnapshotData,
    loading: questionSnapshotLoading,
    refetch: refetchQuestionSnapshots,
  } = useGetQuestionSnapshotBySessionIdQuery({
    variables: { sessionId },
    fetchPolicy: 'network-only',
    skip: !sessionId,
  });

  const intervieweeDetails = sessionData?.getSession;
  const questionSnapshot = questionSnapshotData?.getQuestionSnapshotBySessionId ?? [];
  const intervieweeInfo: IntervieweeInfoType = convertIntervieweeInfo(intervieweeDetails);
  const hasCorruptedVideo = intervieweeDetails?.hasCorruptedVideo === true;

  const warningBox = t('sessionViewer.noticeBox.label');
  const warningBoxLevel = t('sessionViewer.noticeBox.variant') as SnackbarVariants;

  return (
    <div tw="m-auto flex min-h-screen flex-col space-y-5 px-4 py-6 lg:(px-20 py-14)">
      <h3>รายละเอียดการสัมภาษณ์</h3>
      <div tw="sticky top-0 z-10 flex flex-col gap-2">
        <Snackbar text={warningBox} variant={warningBoxLevel} />
        {hasCorruptedVideo && (
          <Snackbar
            text={t('sessionViewer.video.corruptedBanner')}
            variant="error"
          />
        )}
      </div>
      <div tw="flex flex-col gap-2">
        <h5>ผู้สมัคร</h5>
        <IntervieweeCardContainer
          isSessionDataLoading={sessionLoading}
          refetchSession={refetchSession}
          refetchQuestionSnapshots={refetchQuestionSnapshots}
          {...intervieweeInfo}
        />
      </div>
      <QuestionSnapshotContainer
        questionSnapshot={questionSnapshot}
        questionSnapshotLoading={questionSnapshotLoading}
        position={intervieweeInfo?.position}
      />
    </div>
  );
};

export default Interviewee;
